import styled, { keyframes } from 'styled-components';
import { Divider } from 'ui/divider';
import { spacing, colors, duration, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Tag } from 'modules/ai/copyAssist/constants';

export const ICON_SIZE_28 = 28;

// KEYFRAMES
export const scaleIn = keyframes`
    0% {
        transform: scale(0)
    }
    100% {
        transform: scale(1)
    }
`;

export const fadeInScale = keyframes`
    0% {
        opacity: 0;
        scale(0.8);
    }
    100% {
        opacity: 1;
        scale(1);
    }
`;

export const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const fadeInOut = keyframes`
  0% {
      opacity: 1;
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 0;
  }
`;

export type StyledCopyAssistButtonProps = {
  top?: number;
  right?: number;
};

export const StyledCopyAssistButton = styled.div<StyledCopyAssistButtonProps>`
  text-align: right;
  position: absolute;
  top: ${(props) => (props.top ? pxToRem(props.top) : pxToRem(0))};
  right: ${(props) => (props.right ? pxToRem(props.right) : pxToRem(12))};
  cursor: pointer;
  z-index: 2;
`;

export const StyledGenerateAiIcon = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledCopyAssistButtonText = styled.div`
  ${body2}
  color: ${colors.purple100};
  display: inline-block;
  align-items: center;
  padding-left: ${pxToRem(5)};
`;

export const StyledCopyAssistDivider = styled(Divider)`
  margin: ${spacing.half} 0 ${spacing.half} 0;
  background: ${colors.grey15};
  opacity: 0;
  animation-name: ${fadeInScale};
  animation-duration: ${duration.long};
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
`;

export const StyledHighlightOverlay = styled.div`
  top: 0;
  margin: ${spacing.half} ${spacing.threeQuarter};
  position: absolute;
  background-color: ${colors.purple10};
  ${body2};

  &[data-animated='true'] {
    pointer-events: none;
    opacity: 0;
    animation-name: ${fadeInOut};
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }

  &[data-animated='false'] {
    mix-blend-mode: darken;
  }

  &[data-target-tag=${Tag.TextArea}] {
    max-height: 100%;
    margin: ${spacing.half} ${pxToRem(40)} ${spacing.half} ${spacing.threeQuarter};
  }

  &[data-target-tag=${Tag.Input}] {
    max-height: ${pxToRem(22)};
    padding-right: ${spacing.threeEights};
  }
`;

export const StyledHighlightText = styled.span`
  opacity: 0;
`;
export const StyledCopyAssistDropdownBody = styled.div`
  padding: ${spacing.half};

  &:has(+ *) {
    padding-bottom: 0;
  }
`;
